var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlarmLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0834 7.25C17.0834 6.65169 16.5983 6.16666 16 6.16666C15.4017 6.16666 14.9167 6.65169 14.9167 7.25V8.0625H14.3128C11.9023 8.0625 9.90727 9.93668 9.7568 12.3425L9.51738 16.1704C9.4261 17.6298 8.93612 19.0363 8.10081 20.2365C7.34607 21.321 8.01797 22.8188 9.32981 22.9762L13.0209 23.4192V24.5833C13.0209 26.2287 14.3547 27.5625 16 27.5625C17.6454 27.5625 18.9792 26.2287 18.9792 24.5833V23.4192L22.6702 22.9762C23.9821 22.8188 24.654 21.321 23.8993 20.2365C23.0639 19.0363 22.574 17.6298 22.4827 16.1704L22.2433 12.3425C22.0928 9.93668 20.0977 8.0625 17.6872 8.0625H17.0834V7.25ZM14.3128 9.6875C12.7604 9.6875 11.4755 10.8945 11.3786 12.4439L11.1392 16.2718C11.0294 18.028 10.4398 19.7205 9.43459 21.1648C9.38004 21.2432 9.4286 21.3514 9.52342 21.3628L13.5726 21.8487C15.1851 22.0422 16.815 22.0422 18.4275 21.8487L22.4766 21.3628C22.5715 21.3514 22.62 21.2432 22.5655 21.1648C21.5603 19.7205 20.9707 18.028 20.8608 16.2718L20.6214 12.4439C20.5245 10.8945 19.2396 9.6875 17.6872 9.6875H14.3128ZM16 25.9375C15.2521 25.9375 14.6459 25.3312 14.6459 24.5833V23.7708H17.3542V24.5833C17.3542 25.3312 16.7479 25.9375 16 25.9375Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmLine);
export default __webpack_public_path__ + "static/media/icon_alarm_line.829c1eba815743868d761d62c721f4f8.svg";
export { ForwardRef as ReactComponent };